const routes = [
    {
        path: "/finance/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true
        },
        component_full_path: 'financeReports/pages/Index'
    },
    {
        path: "/student/clubs/payment/report",
        component: () => import("../pages/StudentClubsPaymentReport"),
        meta: {
            isAuthenticated: true,
            permission: 'studentclubstudent_financereport'
        }
    }
];

export default routes;
